// extracted by mini-css-extract-plugin
module.exports = {"close":"close_close__207Uv"};